import { createFeatureSelector } from '@ngrx/store';
import { BreakpointReducer, BreakpointState } from './breakpoint.reducer';
import { EliquaReducer, EliquaState } from './eliqua.reducer';
import { EnvironmentReducer, EnvironmentState } from './environment.reducer';
import { GridReducer, GridState } from './grid.reducer';
import { LiteralsReducer, LiteralsState } from './literals.reducer';
import { PaginatorReducer, PaginatorState } from './paginator.reducer';
import { ProgressReducer, ProgressState } from './progress.reducer';
import { RolesReducer, RolesState } from './roles.reducer';

export const featureSharedName = 'SharedStore';

export interface DragonflySharedState {
  breakpoint: BreakpointState;
  environment: EnvironmentState;
  roles: RolesState;
  literals: LiteralsState;
  grid: GridState;
  eliqua: EliquaState;
  paginator: PaginatorState;
  progress: ProgressState;
}

export const moduleSharedReducers = {
  breakpoint: BreakpointReducer,
  environment: EnvironmentReducer,
  roles: RolesReducer,
  literals: LiteralsReducer,
  grid: GridReducer,
  eliqua: EliquaReducer,
  paginator: PaginatorReducer,
  progress: ProgressReducer,
};

export const getDragonflySharedState = createFeatureSelector<DragonflySharedState>(featureSharedName);
